import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLImageElement> {
  connect() {
    document.addEventListener("turbo:before-cache", this.reset);
  }
  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset);
  }

  reset = () => {
    this.element.classList.remove("lazyautosizes");
    this.element.classList.remove("lazyloading");
    this.element.classList.remove("lazyloaded");
    this.element.classList.add("lazyload");
    this.element.src = "";
  };
}
